// react
import { useState } from 'react'
import { Popover } from 'antd'
import WizrButton from '../WizrButton'
import MoreIcon from '../../assets/icons/More'
import EditIcon from '../../assets/icons/EditIcon'
import { dispatchSaveCurrentAppDetails, dispatchDeleteApp, dispatchCreateApp, dispatchCreateAppNewtab, dispatchAppPublished, dispatchAppDraft, dispatchValidateDeletion, dispatchExportWorkflow } from '../../redux/actions/content'
import { dispatchNotificationState } from '../../redux/actions/common'
import Copy from '../../assets/icons/Copy'
import { useNavigate } from 'react-router-dom'
import WizrFlexLayout from '../../components/WizrFlexLayout'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import { useAuth } from '../../authContext'
import styled from 'styled-components'
import ViewIcon from '../../assets/icons/ViewIcon'
import { MODAL_TYPES, useWizrModalContext } from '../../providers/modal/WizrModalProvider'
import Bars from '../../assets/icons/Bars'
import RefreshIcon from '../../assets/icons/refresh'
import PlayIcon from '../../assets/icons/PlayButton'
import WizrLoader from '../WizrLoader'
import DownloadAlt from '../../icons/DownloadAlt'

// const currentAppDetails = useCurrentAppDetailsSelector()



interface IAppActionPopOver {
  detail?: any
  type?: any
}

interface IAppActionPopOverContent {
  onEditAction?: any
  onCopyAction?: any
  onDeleteAction?: any
  type: any
  detail?: any
  onViewAction?: any
  onAppInsightsAction?: any
  onRunHistoryAction?: any
  onRunApiAction?: any
  onDownloadAction?: any
}

const AppActionPopoverContent = ({
  onEditAction,
  onCopyAction,
  onDeleteAction,
  type,
  detail,
  onViewAction,
  onAppInsightsAction,
  onRunHistoryAction,
  onRunApiAction,
  onDownloadAction,
}: IAppActionPopOverContent): JSX.Element => {
  const { hasAcces } = useAuth();
  

  return (
    <WizrFlexLayout textAlign='left' background='#FFF'>
      <WizrButton
        icon={<EditIcon />}
        text='Edit'
        type='text'
        onClick={onEditAction}
        justifyContent='flex-start'
        disabled={!hasAcces('edit_app')}
      // disabled={getAccessStatusEdit()}
      />
      {<WizrButton
        icon={<ViewIcon />}
        text='View'
        type='text'
        onClick={onViewAction}
        justifyContent='flex-start'
        disabled={!hasAcces('view_app-designer')}
      // disabled={getAccessStatusEdit()}
      />}
      <WizrButton
        icon={<Copy />}
        text='Clone'
        type='text'
        onClick={onCopyAction}
        justifyContent='flex-start'
        disabled={!hasAcces('clone_app')}
      />
      {type !== 'template' || type === undefined ? <WizrButton
        icon={<DeleteIcon />}
        text='Delete'
        type='text'
        onClick={onDeleteAction}
        justifyContent='flex-start'
        disabled={!hasAcces('delete_app')}
      />
        : <></>}

      {type === 'published' ? (
        <>
          <WizrButton
            icon={<Bars />}
            text='App Insights'
            type='text'
            onClick={onAppInsightsAction}
            justifyContent='flex-start'
          // disabled={!hasAccess('view_insights')}
          />

          <WizrButton
            icon={<RefreshIcon />}
            text='Run History'
            type='text'
            onClick={onRunHistoryAction}
            justifyContent='flex-start'
          // disabled={!hasAccess('view_history')}
          />

          <WizrButton
            icon={<PlayIcon />}
            text='View Run API'
            type='text'
            onClick={onRunApiAction}
            justifyContent='flex-start'
          // disabled={getAccessStatusEdit()}
          />
          <WizrButton
            icon={<DownloadAlt />}
            text='Download'
            type='text'
            justifyContent='flex-start'
            onClick={() => {
              onDownloadAction()
            }}
          />
        </>
      ) : <></>}
    </WizrFlexLayout>
  )
}

const AppActionPopOver = ({ detail, type }: IAppActionPopOver): JSX.Element => {
  const { showModal, hideModal } = useWizrModalContext()

  const navigate = useNavigate()
  // detail.type = 'app'

  const checkForNewWindow = (e: any) => {
    if (e.ctrlKey || e.metaKey) {

      return true
    } else {

      return false
    }
  }

  const goToCreatePrompt = (e: any, action: string) => {

    const newWindowCheck = checkForNewWindow(e)
    if (newWindowCheck) {
      if (action === 'copy') {
        const { id, app_id, user_name, user_id, ...restOfItem } = detail;
        const appCreatePayload = {
          ...restOfItem,
          app_version: '0',
          app_name: 'Copy of ' + detail?.app_name,
          app_type: 'Tool',
          description: detail?.description,
          tags: detail?.tags,
          memory: detail?.memory,
          created_on: Date.now(),
          updated_on: Date.now(),
          app_category: "general",
          published: false
        }
        dispatchCreateAppNewtab(appCreatePayload)
      }
      else {
        window.open(`/app-designer/tool/${detail?.id}/${detail?.app_id}/edit`, '_blank', 'noopener,noreferrer',);
        //navigate(`/app-designer/tool`, { state: { action, id: detail?.id, appId: detail?.app_id, type: type } })
      }


    } else if (action === 'copy') {
        const { id, app_id, user_name, user_id, ...restOfItem } = detail;
        const appCreatePayload = {
          ...restOfItem,
          app_version: '0',
          app_name: 'Copy of ' + detail?.app_name,
          app_type: 'Tool',
          description: detail?.description,
          tags: detail?.tags,
          memory: detail?.memory,
          created_on: Date.now(),
          updated_on: Date.now(),
          action: 'copy',
          app_category: "general",
          published: false

        }
        dispatchCreateApp(appCreatePayload)
        navigate('/app-designer/tool', { state: { action: 'copy' } })
      } else {
        dispatchSaveCurrentAppDetails(detail)
        navigate(`/app-designer/tool`, { state: { action, id: detail?.id, appId: detail?.app_id, type: type } })
      }
  }

  const cloneTemplate = () => {
    const { id, app_id, tenant_id, ...restOfItem } = detail;
    const appCreatePayload = {
      ...restOfItem,
      app_name: 'Copy of ' + detail?.app_name,
      app_type: 'Tool',
      description: detail?.description,
      tags: detail?.tags,
      memory: detail?.memory,
      type: "app",
      app_version: '0',
    }
    dispatchCreateApp(appCreatePayload)
    navigate('/app-designer/tool', { state: { action: 'copy' } })
  }

  const onCopy = (e: any) => {
    setPopoverOpen(false)
    type === 'template' ? cloneTemplate() : goToCreatePrompt(e, 'copy')
  }

  const onEdit = (e: any) => {
    setPopoverOpen(false)
    type !== 'published' ? goToCreatePrompt(e, 'edit') : goToCreatePrompt(e, 'published_edit')
  }

  const onView = (e: any) => {
    setPopoverOpen(false)
    goToCreatePrompt(e, 'view')
  }

  const onAppInsights = (e: any) => {
    setPopoverOpen(false)
    navigate(`/appInsights/${detail?.app_id}`, { state: { app_id: detail?.app_id, app_name: detail?.app_name } })
  }

  const onRunHistory = (e: any) => {
    setPopoverOpen(false)
    window.open(`/runhistory/${detail?.app_id}`, '_blank', 'noopener,noreferrer')
  }

  const onRunApi = (e: any) => {
    setPopoverOpen(false)
    navigate("/bulkrun", { state: { detail: detail, his: '2', source: 'list' } })
  }

  const onDownload = async () => {
    setPopoverOpen(false)
    try {
      const result = await dispatchExportWorkflow(detail?.app_id)
      // API response body is result.data; create_data lives in result.data.data
      const createData = result?.data?.data?.create_data ?? result?.data?.create_data ?? []
      showModal(MODAL_TYPES.EXPORT_WORKFLOW_WARNING, {
        createData,
      })
    } catch (error) {
      // Error already handled by exportWorkflow thunk
    }
  }

  const [popoverOpen, setPopoverOpen] = useState(false)
  const [isValidatingDeletion, setIsValidatingDeletion] = useState(false)

  const onDelete = async () => {
    setPopoverOpen(false)
    setIsValidatingDeletion(true)
    try {
      const validationResponse = await dispatchValidateDeletion(detail?.app_id)
      console.log(validationResponse);
      
      if (validationResponse?.data?.data.count == 0) {
        showModal(MODAL_TYPES.DELETE_FOLDER, {
          folderName: detail?.app_name,
          folderSize: 0,
          onDeleteConfirm: async () => {
            hideModal()
            await dispatchDeleteApp(detail?.app_id)
            if (type === 'published') {
              dispatchAppPublished()
            }
            else {
              dispatchAppDraft()
            }
          },
          onCancel: hideModal,
        })
      } else {
        dispatchNotificationState({
          message: 'Cannot Delete',
          description: 'This app cannot be deleted as it has active dependencies or is currently in use.',
          type: 'failed',
        })
      }
    } catch (error) {
      console.error(error);
      dispatchNotificationState({
        message: 'Error',
        description: 'Failed to validate deletion. Please try again.',
        type: 'failed',
      })
    } finally {
      setIsValidatingDeletion(false)
    }
  }
  return (
    <>
      {isValidatingDeletion && (
        <WizrLoader
          loading={true}
          fullPage={true}
          useDataAwareLoading={false}
        />
      )}
      <Popover
        content={
          <AppActionPopoverContent
            onCopyAction={onCopy}
            onEditAction={onEdit}
            onViewAction={onView}
            onDeleteAction={onDelete}
            onAppInsightsAction={onAppInsights}
            onRunHistoryAction={onRunHistory}
            onRunApiAction={onRunApi}
            onDownloadAction={onDownload}
            type={type}
            detail={detail}
          />
        }
        trigger='click'
        style={{ margin: '10px' }}
        open={popoverOpen}
        onOpenChange={setPopoverOpen}
      >
        <StyledButton icon={<MoreIcon />} text='' type='text' style={{ height: '40px', width: '40px', borderRadius: '50px' }} />
      </Popover>
    </>
  )
}

export default AppActionPopOver

const StyledButton = styled(WizrButton)`
border-radius: 50%;
width: 20px;
height: 20px;
padding-right: 8px;
justify-content: center;
align-items: center;
  /* Default styles */
  path {
    stroke: #999B9F; /* Default stroke color */
    transition: stroke 0.3s ease; /* Smooth transition for color change */
  }

  /* Hover styles */
  &:hover path {
    stroke: #1D1F22
  }
`;


